export enum ThemesEnum {
    BOOKING_SCHEME_LIGHT_LIGHT = 'BOOKING_SCHEME_LIGHT_LIGHT',
    BOOKING_SCHEME_LIGHT_DARK = 'BOOKING_SCHEME_LIGHT_DARK',
    BOOKING_SCHEME_LIGHT_COLOR = 'BOOKING_SCHEME_LIGHT_COLOR',
    BOOKING_SCHEME_DARK_LIGHT = 'BOOKING_SCHEME_DARK_LIGHT',
    BOOKING_SCHEME_DARK_DARK = 'BOOKING_SCHEME_DARK_DARK',
    BOOKING_SCHEME_DARK_COLOR = 'BOOKING_SCHEME_DARK_COLOR',
}
